@import '~style-sheet-helpers/core.less';
@import '../../../../../../../../../../../src/constants/spacing.module.less';
@import '../../../../../../../../../../../src/constants/screen-width-breakpoints.module.less';

.rule-builder {
  border-top: 1px solid var(--gray-E4E5E7);
  padding-top: @space-16;
  margin-top: @space-12;
  width: 100%;
}

.rule-builder-label {
  margin-bottom: @space-8;
  font-weight: 600;
}

.rule-builder-row {
  align-items: stretch;

  @media @mobile, @ultramobile {
    flex-wrap: wrap;
  }
}

.criteria-dropdown {
  flex: 2;
  min-width: 0;

  @media @mobile, @ultramobile {
    flex-basis: 100%;
  }
}

.operator-dropdown {
  flex: 3;
  min-width: 0;

  @media @mobile, @ultramobile {
    flex-basis: 100%;
  }
}

.currency-input-wrapper {
  flex: 1.5;
  min-width: 0;

  @media @mobile, @ultramobile {
    flex-basis: 100%;
  }
}

.currency-input-height {
  height: 100%;

  input[type='number'] {
    appearance: auto;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      appearance: auto;
      opacity: 1;
    }
  }
}

.save-button {
  align-self: center;
}

.saved-rule-container {
  align-items: center;
  background-color: var(--white);
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  padding: @space-12 @space-16;
  margin-top: @space-12;
  width: 100%;
  flex-wrap: nowrap;
}

.saved-rule-label {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex-shrink: 1;
}

.saved-rule-chip {
  background-color: var(--gray-E4E5E7);
  border-radius: 4px;
  padding: 4px @space-12;
  white-space: nowrap;
  flex-shrink: 0;
}

.saved-rule-spacer {
  flex: 1;
}

.edit-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: @space-4;
  white-space: nowrap;
  flex-shrink: 0;
}
